import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { APP_SETTINGS } from '../models/backofficeConfiguration';
import { ExecuteService } from './executeService.service';
import { ErrorHandlerService } from './errorHandler.service';
import { PostI3 } from '../models/postI3';

@Injectable()
export class PostI3Service {

  constructor(private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService) {
  }

  public GetByUrl(pathName: string, locale: string): Observable<PostI3> {
    let postUrl = '';
    const indexOf = pathName.lastIndexOf('/');
    if (indexOf > -1){
      postUrl = encodeURIComponent(pathName.substring(indexOf + 1).replace(/\//g, '+'));
    }
    else {
      postUrl = encodeURIComponent(pathName.replace(/\//g, '+'));
    }

    const requestUrl = `${APP_SETTINGS.PostI3ApiUrl}/internal/${locale}/post?url=${postUrl}&force=true`;
    return this.executeService.ExecuteWithApiToken('get', requestUrl)
      .pipe(
        catchError((error: any): any => {
          let ignoreNotFound = false;
          if(error.status === 404)
          {
            ignoreNotFound = true;
          }
          return this.errorHandler.handleError<PostI3>('AuthorService_GetAuthors', null, ignoreNotFound);
        }));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/postI3.service.ts